import React from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/site/PublicLayout";
import { StoreButtons } from "@/components/site/StoreButtons";

export default function AboutPage() {
  return (
    <PublicLayout>
      <section className="hero-wash">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 pt-16 pb-16">
          <div className="kicker">About</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-[-0.02em]">
            What Cohnect is (and isn&apos;t)
          </h1>
          <div className="prose-editorial mt-10">
            <p>
              Cohnect is building a simpler way to understand, organize, and strengthen the
              connections in your life. It is operated by <strong>Cohnect LLC</strong>, and it comes
              in two complementary parts.
            </p>
            <p>
              <strong>The app</strong> is a private, interactive map of the people, places, and
              things you know. Link them in plain words and watch your network grow — so you can
              visualize and remember how everyone and everything connects. No account, no ads,
              private to you. It is launching soon on the App Store and Google Play.
            </p>
            <p>
              <strong>The weekly letter</strong> is a free companion that helps you understand
              connection itself — exploring relationships, psychology, technology, and the
              interesting ways people connect around the world. Each issue includes one reconnection
              prompt and one small action you can finish in under ten minutes. Its community lives on
              Discord.
            </p>
            <p>
              Put simply: <strong>the app helps you visualize and remember your connections, while
              the letter helps you understand them.</strong>
            </p>
            <p>
              Cohnect is <strong>not</strong> therapy, counseling, matchmaking, dating, mental-health
              treatment, or professional advice of any kind. It is an editorial publication and a
              personal tool — warm, calm, and practical. Use your own judgment. Not every
              relationship needs to be reopened.
            </p>
          </div>
          <div className="mt-8">
            <div className="kicker">Get the app</div>
            <div className="mt-3"><StoreButtons /></div>
          </div>
          <div className="mt-8">
            <Link to="/issues" className="text-sm font-semibold text-[color:var(--coh-blue)] underline underline-offset-4 decoration-2">Read the weekly letter <span aria-hidden="true" className="font-mono">↗</span></Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
